/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import { buildUrl } from "../../utils/bindUrl";
import {
  IFieldsForm,
  IResponseListFieldsForm,
  IResponseShowFieldsForm,
} from "../../interfaces/fieldsForm";

const BASE = "/fields_forms";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listFieldsForm({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListFieldsForm>(BASE, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showFieldForm({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowFieldsForm>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createFieldForm({
  fieldsForm,
}: {
  fieldsForm: IFieldsForm;
}) {
  const { data } = await api.post<IResponseShowFieldsForm>(BASE, { fieldsForm });
  return data;
}

export async function updateFieldForm({
  id,
  fieldsForm,
}: {
  id: string | number;
  fieldsForm: IFieldsForm;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowFieldsForm>(url, { fieldsForm });
  return data;
}

export async function deleteFieldForm({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.delete<any>(url);
  return data;
}
